// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Spinner = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Spinner = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  var getSizeClassName = function getSizeClassName(size) {
    switch (size) {
      case 5:
        return 'cop-h-5 cop-w-5';
      case 10:
      default:
        return 'cop-h-10 cop-w-10';
    }
  };

  /**
   * Spinner component is used to indicate a loading state of a component or page.
   */
  var Spinner = _exports.Spinner = function Spinner(_ref) {
    var size = _ref.size;
    return /*#__PURE__*/React.createElement("svg", {
      className: "".concat(getSizeClassName(size), " cop-animate-rotate"),
      color: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "22 22 44 44"
    }, /*#__PURE__*/React.createElement("circle", {
      className: "cop-animate-dash-circle",
      cx: "44",
      cy: "44",
      r: "20.2",
      stroke: "currentColor",
      strokeWidth: "3.6",
      strokeDasharray: "1,200",
      strokeDashoffset: "0"
    }));
  };
});
